import type { SkeletonProps } from '@mui/material';
import { Skeleton } from '@mui/material';
import React from 'react';

const SkeletonLoader: React.FC<
  {
    children: React.ReactNode;
    loading: boolean;
    count?: number;
  } & SkeletonProps
> = ({
  children = null,
  loading = false,
  count = 1,
  variant = 'rounded',
  animation = 'wave',

  ...skeletonProps
}) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!loading) return <>{children}</>;

  return (
    <>
      {Array.from(Array(count)).map((_key, index) => (
        <Skeleton
          key={`skeleton-loader-${index}`}
          {...skeletonProps}
          animation={animation}
          variant={variant}
          sx={{ my: 0.5 }}
        />
      ))}
    </>
  );
};

export default SkeletonLoader;
